import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { IconX } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useMerchantRequestAcceptMutation } from "../../../apis/merchantApis";
import { useLanguage } from "../../../context/LanguageContext";
import AddClientCreateRequestModal from "./AddMerchantCreateRequestModal";

interface Props {
  request: any;
  onClose: () => void;
}

export default function AddMerchantCreateRequestSidebar({ request, onClose }: Props) {
  const { t } = useLanguage();
  const [allIds, setAllIds] = useState<any>();

  const { mutate: requestAcceptMutate, isPending } = useMerchantRequestAcceptMutation();

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm<any>();

  useEffect(() => {
    if (request) {
      reset({
        id: request.id,
        name: request.name || "",
        email: request.email || "",
        mobileNumber: request.mobileNumber ? request.mobileNumber.slice(1) : "",
        clientType: "",
        warehouseId: "",
        city: "",
        shippingCost: "",
        address: "",
      });
    }
  }, [request, reset]);

  const getIds = (idData: any) => {
    setAllIds(idData);
  };

  const handleCreate = (formData: any) => {
    requestAcceptMutate(
      { ...formData, ...allIds },
      {
        onSuccess: () => {
          toast.success(t("Merchant Created and Accepted"));
          window.dispatchEvent(new CustomEvent("refetchRequests"));
          reset();
          onClose();
        },
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong";
          toast.error(errorMessage);
        },
      },
    );
  };

  return (
    <div className="relative bg-white rounded-3xl shadow-sm border flex flex-col overflow-hidden h-full">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-[#212121]">{t("Add Merchant")}</h2>

        <div className="flex items-center gap-3">
          <button
            onClick={handleSubmit(handleCreate)}
            disabled={isPending}
            className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg disabled:opacity-50"
          >
            {isPending ? t("Creating...") : t("Create")}
          </button>

          <button
            onClick={onClose}
            className="p-2 rounded-lg border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto bg-[#faf8ec] p-4">
        <AddClientCreateRequestModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          getIds={getIds}
          control={control}
          watch={watch}
        />
      </div>
    </div>
  );
}
